export enum BaseHeaderXCache {
  HIT = 'HIT',
}
export interface BaseHeaderResponse {
  'x-cache'?: BaseHeaderXCache;
  'x-request-id'?: string;
}
